import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { COMPANY } from "../lib/data";

export default function StickyCTA() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-cta"
      className={`fixed bottom-0 left-0 w-full z-40 lg:hidden transition-transform duration-300 ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="bg-white/90 backdrop-blur-xl border-t border-slate-200 shadow-[0_-6px_20px_-10px_rgba(15,23,42,0.2)] px-4 py-3 flex items-center justify-between gap-3">
        <div className="flex flex-col">
          <span className="text-[0.7rem] font-bold uppercase tracking-wide text-brand">
            Urgence 24/7
          </span>
          <span className="font-display font-extrabold text-ink text-lg leading-none">
            {COMPANY.phone}
          </span>
        </div>
        <a href={COMPANY.phoneHref} data-testid="sticky-call-btn" className="btn-primary flex-1 max-w-[52%]">
          <Phone className="h-4 w-4" /> Appeler
        </a>
      </div>
    </div>
  );
}
